<template>
	<div class="">
		<el-dialog :title="`投票表决`" :visible.sync="voteDialogVisible" v-if="voteDialogVisible" :before-close="closeVote"
			width="720px" top="23vh" :close-on-click-modal="false" :close-on-press-escape="false">
			<div class="vote" v-loading="loading">
				<!-- <ul> -->
				<!-- <li class="vote-name">
		                <h3>
		                    <i class="iconfont icon-shuxian"></i>
		                    <span>表决事项</span>
		                </h3>
		                <p>{{ voteInfo.name }}</p>
		            </li>
		            <li class="vote-name">
		                <h3>
		                    <i class="iconfont icon-shuxian"></i>
		                    <span>表决内容</span>
		                </h3>
		                <p>{{ voteInfo.content }}</p>
		            </li> -->
				<div class="" style="width: 100%;margin-bottom: 20px;">
					<div class="flex align-center justify-center"
						style="background-color: rgba(38,101,255,0.05);width: 100%;padding: 20px 0px;border-radius: 5px 5px 0px 0px;">
						<div class="" style="width: 90%;">
							<div class="flex justify-between">
								<div class="vote-name_ml" style="width: 12%;">
									表决事项
								</div>
								<div class="vote-content_ml" style="width: 88%;">
									{{ voteInfo.name }}
								</div>
							</div>
							<div class="flex justify-between" style="margin-top: 14px;">
								<div class="vote-name_ml" style="width: 12%;">
									表决内容
								</div>
								<div class="vote-content_ml" style="width: 88%;">
									{{ voteInfo.content }}
								</div>
							</div>
						</div>
					</div>
					<div class="flex align-center justify-center"
						style="background-color: rgba(255,141,26,0.1);width: 100%;padding: 20px 0px;border-radius: 0px 0px 5px 5px;">
						<div class="" style="width: 90%;">
							<div class="flex justify-between">
								<div class="vote-name_ml" style="width: 10%;">
									债权人
								</div>
								<div class="vote-content_ml flex align-center justify-between" style="width: 90%;">
									<div class="flex align-center" style="width: 50%;">
										<div class="">
											姓名
										</div>
										<div class="" style="margin-left: 10px;">
											{{userData.name}}
										</div>
									</div>
									<div class="flex align-center" style="width: 50%;">
										<div class="">
											证件号
										</div>
										<div class="" style="margin-left: 10px;">
											{{userData.username}}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>


				<template v-if="voteType === 'SINGLE_CHOICE'">
					<li v-for="(item, cindex) in groupingList" :key="item.groupId" class="vote-name">
						<h3>
							<!-- <i class="iconfont icon-shuxian"></i> -->
							<span>{{ item.name }}
							</span>
						</h3>
						<ul class="vote-ul">
							<li class="vote-li" :class="citem.isFlag ? 'active' : ''"
								v-for="(citem, index) in item.options" :key="index"
								@click.stop="changeVote(index, cindex)">
								{{ citem.name }}
							</li>
						</ul>
					</li>
				</template>
				<template v-else>
					<li v-for="(item, i) in groupingList" :key="item.groupId" class="vote-name">
						<h3>
							<!-- <i class="iconfont icon-shuxian"></i> -->
							<span>{{ item.name }}
							</span>
							<span v-if="voteInfo.numerator != 0" class="sign">(请选择{{ voteInfo.numerator }}个方案)</span>
						</h3>
						<ul class="vote-ul">
							<li v-if="citem.isShow && voteType == 'ELECT'" class="vote-li"
								:class="citem.isFlag ? 'active' : ''" v-for="(citem, index) in item.options"
								:key="index" @click.stop="changeCandidate(citem, i, item.groupPeople)">
								{{ citem.name }}
							</li>
							<li v-if="voteType != 'ELECT'" class="vote-li" :class="citem.isFlag ? 'active' : ''"
								v-for="(citem, index) in item.options" :key="index"
								@click.stop="changeCandidate(citem, i, item.groupPeople)">
								{{ citem.name }}
							</li>
						</ul>
						<div v-if="voteType=='ELECT'&& voteInfo.enableRecommend" class="">
							<div class="" style="display: flex;align-items: center;position: relative;">
								<div class="" style="font-size: 16px;color: #606266;font-weight: 600;">
									我要推荐
								</div>
								<el-button plain v-if="voteText === '立即表决'" @click="dialogVisibleShow(i)"
									style="margin-left: 15px;" class="button-new-tag buttonnoen" size="small">+ 添加推荐人
								</el-button>
								<div v-if="dialogVisible[i].type" class=""
									style="position: absolute;top: -200px;border: 1px solid #CCCCCC;background-color: #FFFFFF;border-radius: 5px;margin-top: 10px;padding: 10px;left: -252px;width: 210px;">
									<div class=""
										style="display: flex;justify-content: space-between;margin-bottom: 5px;">
										<div class="">
											可推荐1人
										</div>
										<i @click="dialogVisibleClose(i)" class="el-icon-close"
											style="font-size: 18px;"></i>
									</div>
									<div class=""
										style="border-bottom: 2px solid #2766ff;margin-bottom: 10px;padding-bottom: 10px;">
										<el-input v-model="keyword" placeholder="请输入搜索关键字" prefix-icon="el-icon-search">
										</el-input>
									</div>
									<div class="" style="width: 100%;height: 350px;overflow-y: auto;">
										<div v-if="keyword==''||item.name.includes(keyword)"
											@click="selectCreatorUserList(item,i)" class=""
											v-for="item in creatorUserLists">
											<el-button
												style="width: 190px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow:ellipsis;text-align: left;"
												type="text">{{item.name}}</el-button>
										</div>
									</div>
								</div>
							</div>
							<div class="" style="display: flex;flex-flow: wrap;margin: 15px 20px;">
								<div class="" v-for="(item,index) in selectList[i]"
									style="border: 1px solid #E5E5E5;margin-right: 20px;display: flex;align-items: center;border-radius: 3px;padding: 5px 20px;margin-bottom: 15px;color: #74798C;line-height: 20px;font-size: 14px;">
									<div class="">
										{{item.name}}
									</div>
									<div v-if="!isVote || !isDisabledButton" class="" style="margin-left: 10px;">
										<i @click="deleteSelectList(index,i)" class="el-icon-close"
											style="font-size: 14px;"></i>
									</div>
								</div>
							</div>
						</div>
					</li>
				</template>
				<!-- </ul> -->
			</div>
			<div class="btn">
				<el-button style="width: 120px;" type="primary"
					:class="(disabled || isVote || isDisabledButton) ? 'disabled' : ''" :loading="btnLoading"
					@click="immediateVote" :disabled="(disabled || isVote)">{{
		    voteText
		            }}</el-button>
			</div>
		</el-dialog>
		<el-dialog title="反对理由" :visible.sync="objectionDialogVisible" width="30%" top="10%"
			:close-on-click-modal="false" :close-on-press-escape="false">
			<div v-if="remarkList.length>0" class="" style="width: 100%;">
				<el-input type="textarea" :rows="6" :placeholder="`请输入反对理由，字数不少于${voteInfo.reasonWordNum}字`"
					v-model="remark" :disabled="objectionAstrict">
				</el-input>
				<div class="flex align-center justify-end" style="margin-top: 10px;">
					已输入{{remark.length}}字，不少于{{voteInfo.reasonWordNum}}字
				</div>
			</div>
			<span v-if="!objectionAstrict" slot="footer" class="dialog-footer">
				<el-button @click="objectionDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitObjection">确 定</el-button>
			</span>
		</el-dialog>
	</div>

</template>

<script>
	import {
		mapState
	} from 'vuex';
	import {
		getVoteDetail,
		getUserGrouping,
		voteByBallot,
		getVotingRecords
	} from '@/serve/userGrouping';
	export default {
		props: {
			userData: {},
			voteDialogVisible: Boolean,
			status: Number
		},
		data() {
			return {
				isVoteRecord: false,
				isVote: false,
				voteText: '立即表决',
				btnLoading: false,
				loading: false,
				currentId: '',
				voteInfo: {},
				groupingList: [],
				ids: [],
				voteRecords: {},
				isWaiver: false,
				allowPartVote: false, //是否允许分组投票
				synchronizationVote: [], // 同步表决
				groupVoteRecordList: [],
				voteType: '', // 选项类型
				voteList: [],
				active: '1',
				disabled: true,
				dialogVisible: [],
				keyword: '',
				creatorUserList: [],
				creatorUserLists: [],
				selectList: [],
				objectionDialogVisible: false,
				remarkIndex: 0,
				remarkList: [],
				remark: '',
				objectionAstrict: false,
			};
		},
		computed: {
			...mapState({
				userInfo: (state) => state.user.userInfo
			}),
			// disabled() {
			//     if (this.voteType === 'SINGLE_CHOICE') {
			//         return this.groupVoteRecordList.length !== this.groupingList.length;
			//     }
			//     return false
			// },

			isDisabledButton() {
				if (this.voteInfo.voteType === 'MULTIPLE_CHOICE') {
					return this.groupingList.some(group => {
						let count = 0;
						(group.options || []).some(item => {
							if (item.name === "弃权" && item.isFlag) {
								count = this.voteInfo.numerator;
							} else if (item.isFlag) {
								count++;
							}
						})
						return count !== this.voteInfo.numerator
					})
				} else if (this.voteInfo.voteType === 'ELECT') {
					return this.groupingList.some(group => {
						let count = 0;
						(group.options || []).some(item => {
							if (item.name === "弃权" && item.isFlag) {
								count = this.voteInfo.numerator;
							} else if (item.isFlag) {
								count++;
							}
						})
						return count !== this.voteInfo.numerator
					})
				} else {
					return !this.groupingList.every(group => (group.options || []).some(item => item.isFlag))
				}
			}
		},
		created() {
			this.meetingId = this.userData.meetingId
			this.userId = this.userData.userId
			this.voteId = this.userData.voteId
			this.getVotingRecords();
		},
		methods: {
			submitObjection() {
				console.log("remarkList", this.remarkList);
				if (this.remark == '') {
					this.$message({
						message: `请输入反对理由，字数不少于${this.voteInfo.reasonWordNum}字`,
						type: 'error'
					});
					return
				} else if (this.remark.length < this.voteInfo.reasonWordNum) {
					this.$message({
						message: `字数不少于${this.voteInfo.reasonWordNum}字`,
						type: 'error'
					});
					return
				}
				if (this.allowPartVote) {
					this.remarkList[this.remarkIndex].name = this.remark;
				} else {
					this.remarkList[0].name = this.remark;
				}
				this.objectionDialogVisible = false;
			},
			dialogVisibleShow(index) {
				if (this.groupingList[index].isWaiver) {
					return this.$message('当前您已选择弃权，若要添加推荐人，请点击取消弃权!');
				}
				this.dialogVisible[index].type = !this.dialogVisible[index].type;
				for (let i in this.dialogVisible) {
					if (index != i) {
						this.dialogVisible[i].type = false;
					}
				}
				this.creatorUserListInit(index);
				console.log("dialogVisible", this.dialogVisible)
			},
			deleteSelectList(index, i) {
				this.selectList[i].splice(index, 1);
				this.filteredArray(i);
			},
			dialogVisibleClose(index) {
				this.keyword = '';
				this.dialogVisible[index].type = false;
			},
			selectCreatorUserList(item, index) {
				if (this.selectList[index].length == 0) {
					this.selectList[index].push(item);
					this.filteredArray(index);
				} else {
					this.$message.error('推荐人已满');
				}
			},
			creatorUserListInit(index) {
				let list = [];
				console.log("voteInfo", this.voteInfo)
				for (let i in this.voteInfo.options) {
					if (!this.voteInfo.options[i].isShow) {
						list.push(this.voteInfo.options[i])
					}
				}
				let lists = [];
				for (let i in this.voteInfo.groups) {
					lists.push(list);
				}
				this.creatorUserList = lists;
				console.log("selectList", lists)
				this.filteredArray(index);
			},
			filteredArray(index) {
				this.creatorUserLists = this.creatorUserList[index].filter(itemA => {
					return !this.selectList[index].some(itemB => itemB.name === itemA.name)
				})
			},
			finishVote() {
				this.btnLoading = false;
				this.voteText = '已完成表决';
				this.isVote = true;
			},
			// 获取用户在当前会议下的投票记录
			getVotingRecords() {
				getVotingRecords({
						meeting_id: this.userData.meetingId,
						user_id: this.userData.userId
					})
					.then((res) => {
						this.voteRecords = res;
						this.getVoteDetail();
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 同步表决
			syncVote() {
				let synchronizationVote = window.localStorage.getItem('synchronizationVote');
				if (synchronizationVote) {
					synchronizationVote = JSON.parse(synchronizationVote);
					synchronizationVote.push(this.voteId);
					window.localStorage.setItem('synchronizationVote', JSON.stringify(synchronizationVote));
				} else {
					this.synchronizationVote.push(this.voteId);
					window.localStorage.setItem('synchronizationVote', JSON.stringify(this.synchronizationVote));
				}
			},
			// 立即表决
			immediateVote() {
				if (this.isDisabledButton) {
					return
				}
				this.$confirm('投票一旦提交不可更改, 请确认是否提交?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass: 'del-model',
					type: 'warning'
				}).then(() => {
					this.btnLoading = true;
					if (this.voteType === 'SINGLE_CHOICE') {
						let groupVoteRecordList = this.groupVoteRecordList.map(item => ({
							...item,
							voteWay: 'SELF'
						}))
						let list = [];
						for (let j = 0; j < this.voteInfo.groups.length; j++) {
							if (this.voteInfo.groups[j].options != undefined) {
								list.push(this.voteInfo.groups[j]);
							}
						}
						console.log("voteInfo", this.voteInfo)
						console.log("groupVoteRecordList", this.groupVoteRecordList)
						if (this.voteInfo.isReason) {
							if (this.allowPartVote) {
								for (let i = 0; i < this.remarkList.length; i++) {
									if (this.remarkList[i].name == '' && this.remarkList[i].id == '反对') {
										this.$message.error(`请填写“${list[i].name}”反对理由`);
										this.btnLoading = false;
										return
									}
								}
								for (let i = 0; i < groupVoteRecordList.length; i++) {
									if (this.remarkList[i].id == '反对') {
										groupVoteRecordList[i].remark = this.remarkList[i].name;
									}

								}
							} else {
								if (this.remarkList[0].name == '' && this.remarkList[0].id == '反对') {
									this.$message.error(`请填写反对理由`);
									this.btnLoading = false;
									return
								}
								if (this.remarkList[0].id == '反对') {
									for (let i = 0; i < groupVoteRecordList.length; i++) {
										groupVoteRecordList[i].remark = this.remarkList[0].name;
									}
								}
							}
						}
						console.log("groupVoteRecordList", groupVoteRecordList)
						// return
						voteByBallot({
								creditorId: this.userId,
								groupVoteRecordList: groupVoteRecordList,
								voteId: this.voteId
							})
							.then(() => {
								this.$message.success('表决成功');
								this.$emit('finish')
							})
							.catch((err) => {
								if (err.status === 400 && !err.data.success) {
									this.$message.error(err.data.message);
									this.finishVote();
								}
							});
					} else {
						let selectList = JSON.parse(JSON.stringify(this.selectList));
						let voteInfo = JSON.parse(JSON.stringify(this.voteInfo));
						if (this.voteType === 'ELECT') {
							let list = [];
							for (let i = 0; i < voteInfo.groups.length; i++) {
								if (voteInfo.groups[i].options != undefined) {
									list.push(voteInfo.groups[i]);
								}
							}
							voteInfo.groups = list;
							let type = false;
							for (let i = 0; i < voteInfo.groups.length; i++) {
								if (voteInfo.groups[i].options) {
									for (let j = 0; j < voteInfo.groups[i].options.length; j++) {
										if (selectList[i][0] != undefined) {
											if (voteInfo.groups[i].options[j].id == selectList[i][0].id) {
												voteInfo.groups[i].options[j].isFlag = true;
											}
											if (voteInfo.groups[i].options[i].name == '弃权') {
												type = true;
											}
										} else {
											if (voteInfo.enableRecommend) {
												if (voteInfo.groups[i].options[0].isFlag && voteInfo.groups[i]
													.options[
														0]
													.name == '弃权') {
													if (!voteInfo.groups[i].options[0].isFlag && selectList[i]
														.length ==
														0) {
														this.$message.error("请选择推荐人");
														this.btnLoading = false;
														return
													}
												} else {
													if (selectList[i].length ==
														0) {
														this.$message.error("请选择推荐人");
														this.btnLoading = false;
														return
													}
												}
											}

										}
									}
								}
							}
						}
						let groupVoteRecordList = (voteInfo.groups || []).map(item => ({
							groupId: item.groupId,
							voteId: this.voteId,
							optionIds: (item.options || []).filter(elm => elm.isFlag).map(cc => cc.id),
							voteWay: 'AGENT_SPLIT'
						})).filter(item => item.optionIds.length)
						console.log("groupVoteRecordList", groupVoteRecordList)
						// return
						voteByBallot({
								creditorId: this.userId,
								groupVoteRecordList,
								voteId: this.voteId
							})
							.then(() => {
								this.$message.success('表决成功');
								this.$emit('finish')
							})
							.catch((err) => {
								if (err.status === 400 && !err.data.success) {
									this.$message.error(err.data.message);
									// this.finishVote();
									this.btnLoading = false;
								}
							});
					}
				});
			},
			// 选择代表
			changeCandidate(item, index) {
				if (this.disabled || this.isVote) {
					return
				}
				const obj = this.groupingList[index]
				if (item.name === '弃权') {
					item.isFlag = !item.isFlag;
					if (item.isFlag) {
						for (let i = 0; i < obj.options.length; i++) {
							let ktem = obj.options[i];
							if (item.id === ktem.id) {
								ktem.isFlag = true;
							} else {
								ktem.isFlag = false;
							}
						}
						obj.isWaiver = true;
						this.selectList[index] = [];
						this.dialogVisible[index].type = false;
						this.$message('您已选择弃权');
						return;
					} else {
						obj.isWaiver = false;
						return
					}
				}
				if (obj.isWaiver) {
					return this.$message('当前您已选择弃权，若重新选择，请点击取消弃权!');
				}
				// 判断数量
				let count = 0;
				obj.options.forEach(item => {
					if (item.isFlag) {
						count++
					}
				})
				// 取消选中
				if (item.isFlag) {
					item.isFlag = false;
					obj.isWaiver = false;
					return;
				}
				// 添加选中
				if (count < this.voteInfo.numerator) {
					item.isFlag = true;
				} else {
					// 重复 - 提示弹窗
					this.$message(`当前已有${this.voteInfo.numerator}个方案`);
				}
				obj.isWaiver = false;
			},
			// 选票（同意&反对）
			changeVote(index, cindex) {
				if (this.isVoteRecord) {
					console.log("groupVoteRecordList", this.groupVoteRecordList)
					console.log("remarkList", this.remarkList)
					if (this.remarkList[cindex].id == '反对') {
						this.remark = this.remarkList[cindex].name;
						this.objectionAstrict = true;
						this.objectionDialogVisible = true;
					}
					return;
				}
				if (this.allowPartVote) {
					let listItem = this.groupingList[cindex];
					listItem.options.forEach((item) => {
						item.isFlag = false;
					});
					listItem.options[index].isFlag = true;
					this.groupVoteRecordList = this.groupVoteRecordList.filter((item) => item.groupId !== listItem
						.groupId);
					listItem.options.forEach((item) => {
						if (item.isFlag) {
							this.groupVoteRecordList.push({
								groupId: listItem.groupId,
								voteId: item.voteId,
								optionIds: [item.id],
								remark: '',
							});
						}
					});
					if (listItem.options[index].isFlag && listItem.options[index].name == '反对' && this.voteInfo.isReason) {
						this.remark = '';
						if (this.remarkList[cindex].name != '') {
							this.remark = this.remarkList[cindex].name
						}
						this.remarkList[cindex].id = '反对';
						this.objectionDialogVisible = true;
						this.remarkIndex = cindex;
					} else if (listItem.options[index].isFlag && listItem.options[index].name == '同意') {
						this.remarkList[cindex].id = '';
						this.remarkList[cindex].name = '';
					}
				} else {
					this.groupVoteRecordList = [];
					this.groupingList.forEach((item, indexs) => {
						item.options.forEach((citem, cindex) => {
							citem.isFlag = false;
							if (cindex == index) {
								citem.isFlag = true;
								this.groupVoteRecordList.push({
									groupId: item.groupId,
									voteId: item.voteId,
									optionIds: [citem.id],
									remark: '',
								});
								if (this.voteInfo.isReason && citem.isFlag && citem.name == '反对') {
									this.remark = '';
									if (this.remarkList[indexs].name != '') {
										this.remark = this.remarkList[indexs].name
									}
									this.remarkList[indexs].id = '反对';
									this.objectionDialogVisible = true;
									this.remarkIndex = indexs;
								} else if (citem.isFlag && citem.name == '同意') {
									this.remarkList[indexs].id = '';
									this.remarkList[indexs].name = '';
								}
							} else {
								citem.isFlag = false;
							}
						});
					});
				}
			},
			// 获取详情
			getVoteDetail() {
				this.loading = true;
				getVoteDetail(this.voteId)
					.then((res) => {
						this.voteInfo = res;
						this.voteType = res.voteType;
						this.allowPartVote = res.allowPartVote; // 是否允许分组投票
						this.voteInfo.options.forEach((item) => {
							this.$set(item, 'isFlag', false);
						});
						if (this.voteInfo.voteType == 'ELECT') {
							for (let i in this.voteInfo.groups) {
								this.dialogVisible.push({
									type: false
								})
								this.selectList.push([])
							}
						}
						this.getUserGrouping();
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error(err.data.message);
					});
			},
			// 获取当前用户所属组别
			getUserGrouping() {
				getUserGrouping(this.meetingId, this.userId)
					.then((res) => {
						this.loading = false;
						// 当前用户存在的组别进行筛选
						let arr = res.map((item) => item.groupId);
						this.groupingList = this.voteInfo.groups.filter((item) => arr.indexOf(item.groupId) > -1);
						this.groupingList = this.groupingList.map((item) => {
							item.groupPeople = res.filter((elm) => elm.groupId === item.groupId);
							return item;
						});
						this.groupingList.forEach((item) => {
							this.$set(item, 'options', JSON.parse(JSON.stringify(this.voteInfo.options)));
						});
						if (this.voteRecords[this.voteInfo.id]) {
							// 几选几
							if (this.voteInfo.voteType === 'MULTIPLE_CHOICE' || this.voteInfo.voteType === 'ELECT') {
								this.groupingList.forEach(group => {
									group.options.forEach((item) => {
										this.voteRecords[this.voteInfo.id].forEach(elm => {
											if (elm.groupId === group.groupId) {
												elm.optionIds.forEach(
													(id) => {
														if (id === item.id) {
															item.isFlag = true;
														}
													}
												);
											}
										})

									});
								})
								// console.log("this.status",this.status)
								if (this.voteInfo.voteType === 'ELECT') {
									for (let i in this.groupingList) {
										// this.selectList.push([]);
										for (let z in this.groupingList[i].options) {
											if (!this.groupingList[i].options[z].isShow && this.groupingList[i]
												.options[z].isFlag) {
												this.selectList[i].push(this.groupingList[i].options[z]);
												console.log("ssss", this.groupingList[i].options[z])
											}
										}

									}
								}
								this.isVoteRecord = true;
								this.finishVote();
							} else {
								// 同意&反对
								let isFinish = false
								this.groupingList.forEach((item) => {
									this.voteRecords[this.voteInfo.id].forEach((citem) => {
										// && citem.voteWay === 'AGENT_SPLIT'
										if (item.groupId === citem.groupId) {
											item.options.forEach((vitem) => {
												if (citem.optionIds[0] === vitem.id) {
													vitem.isFlag = true;
													isFinish = true
												}
											});
											if (citem.remark != '' && item.remark == undefined) {
												item.remark = citem.remark
											}
										}
									});
								});
								if (isFinish) {
									this.isVoteRecord = true;
									this.finishVote();
								}
								for (let i = 0; i < this.groupingList.length; i++) {
									if (this.groupingList[i].remark != undefined) {
										this.remarkList.push({
											id: '反对',
											name: this.groupingList[i].remark
										})
									} else {
										this.remarkList.push({
											id: '',
											name: ''
										})
									}
								}
							}
						} else {
							if (this.status == 0) {
								this.btnLoading = false;
								this.voteText = '表决已结束';
								this.isVote = true;
							}
						}
						if (this.voteInfo.voteType == 'SINGLE_CHOICE' && this.remarkList.length == 0) {
							for (let i in this.voteInfo.groups) {
								if (this.voteInfo.groups[i].options != undefined) {
									console.log("ji")
									this.remarkList.push({
										id: '',
										name: ''
									})
								}
							}
						}
						this.disabled = false;
						console.log("remarkList", this.remarkList)
					})
					.catch((err) => {
						this.loading = false;
						console.log('err', err)
						this.$message.error('组别获取失败');
					});
			},
			closeVote() {
				this.keyword = '';
				this.selectList = [];
				this.creatorUserList = [];
				this.creatorUserLists = [];
				this.$emit('close');
			}
		}
	};
</script>
<style scoped lang="scss">
	.buttonnoen:focus,
	.buttonnoen:hover,
	.buttonnoen:active {
		outline: none;
		box-shadow: none;
		background-color: #FFFFFFF;
		border: 1px solid #dcdfe6 !important;
		color: #606266 !important;
	}

	.vote-name_ml {
		font-size: 14px;
		font-family: Source Han Sans CN-Medium, Source Han Sans CN;
		font-weight: bold;
		color: #282F36;
		line-height: 17px;
	}

	.vote-content_ml {
		font-size: 14px;
		font-family: Source Han Sans CN-Regular, Source Han Sans CN;
		font-weight: 400;
		color: #74798C;
		line-height: 17px;
	}

	.box-card {
		padding-bottom: 20px;

		.btn {
			margin-top: 50px;
			text-align: center;

			.disabled {
				background: #d2cece;
				border: 1px solid #d2cece;
			}
		}

		.vote {
			.menu {
				margin-bottom: 30px;
			}

			.vote-name {
				list-style: none;
				margin-bottom: 20px;

				h3 {
					display: flex;
					justify-content: flex-start;
					align-items: center;

					i {
						color: #c22929;
						font-size: 25px;
					}

					.sign {
						color: #c22929;
						font-size: 16px;
						margin-left: 15px;
						letter-spacing: 2px;
					}
				}

				p {
					line-height: 30px;
					text-indent: 1.5em;
				}
			}
		}

		.vote-ul {
			padding-left: 20px;
			margin-top: 15px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			flex-wrap: wrap;

			.vote-li {
				list-style: none;
				padding: 5px 20px;
				margin-right: 20px;
				border: 1px solid #E5E5E5;
				font-size: 14px;
				font-family: Source Han Sans CN-Regular, Source Han Sans CN;
				font-weight: 400;
				color: #74798C;
				line-height: 20px;
				border-radius: 3px;
				margin-bottom: 15px;

				&.active {
					border: 1px solid #B2C7FF;
					color: #2766FF;
					background: #EAF1FF;
				}

				&:hover {
					cursor: pointer;
				}
			}
		}

		.vote-list {
			padding-left: 20px;
			margin-top: 15px;

			.vote-li {
				display: inline-block;
				margin-bottom: 10px;
				list-style: none;
				padding: 5px 20px;
				margin-right: 20px;
				border: 2px solid #d2cece;

				&.active {
					border: 2px solid #c22929;
					color: #c22929;
				}

				&:hover {
					cursor: pointer;
				}
			}
		}
	}
</style>